import { User } from './UserModels';

export class AuthRequest {
  username: string = '';
  password: string = '';
}

export class RefreshTokenRequest {
  refreshToken: string;

  constructor(refreshToken: string) {
    this.refreshToken = refreshToken;
  }
}

export interface AuthResponse {
  user: User;
  token: string;
  refreshToken: string;
}

export interface ApiKey {
  id: number;
  name: string;
  description: string;
  createdAt: Date;
  lastUsedAt?: Date;
  expiresAt?: Date;
  isActive: boolean;
  createdBy: string;
}

export class CreateApiKeyRequest {
  name: string = '';
  description: string = '';
  expiresAt?: Date = undefined;
  username: string = '';
}

export interface CreateApiKeyResponse {
  id: number;
  name: string;
  description: string;
  key: string;
  createdAt: Date;
  lastUsedAt?: Date;
  expiresAt?: Date;
  isActive: boolean;
  createdBy: string;
}
